import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { DataSource, RequestMetadata, PagedResult, DataType } from 'lib/ng-crud-table';
import { environment } from 'src/environments/environment';
import { NotifyService } from 'lib/notify';
import { request } from 'http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService implements DataSource {
  url: string = 'assets/ng-crud-table/players.json';

  primaryKeys: string[] = ['id'];


  constructor(private http: HttpClient, private notifyService: NotifyService) { }

  //Clear All Filters - IMP
  clearAllFilters() {

  }

  getConfigsList(type: number, MapID: string) {
    let params = new HttpParams()
      .set('type', type.toString())
      .set('MapID', MapID);

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers,
      params: params
    };

    this.url = environment.urlAddress + '/api/GoogleMaps/GetGMapsData';
    return this.http.get<any>(this.url, options);
  }
  getRegConfigsList(type: number, CriteriaName: string, RegNames: string) {
    debugger;
    let params = new HttpParams()
      .set('type', type.toString())
      .set('criteriaName', CriteriaName)
      .set('RegNames', RegNames);

    
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers,
      params: params
    };

    this.url = environment.urlAddress + '/api/GoogleMaps/GetMapRegion';//GetGMapsRegionData';
    return this.http.post<any>(this.url, {}, options);
  }

  //https://stackoverflow.com/questions/45480311/make-a-service-variable-global-in-angular-2
  Rows:string ="";
  //Latest maps config rows set here
  setRows(data) {
    this.Rows = data;
  }

  async getItems(requestMeta: RequestMetadata): Promise<PagedResult> {
    //console.log(requestMeta.pageMeta)
    const currentPage = requestMeta.pageMeta.currentPage;
    const perPage = requestMeta.pageMeta.perPage;
    const pageCount = requestMeta.pageMeta.pageCount;
    const data = this.Rows;
    const rows: any[] = JSON.parse(data) as any[] || [];
    const totalCount = rows.length;
    const result = {
      items: rows,
      _meta: {
        totalCount,//number of records totally
        pageCount,//number of records in current page
        currentPage,//page number selected
        perPage//selected option for number of records to be actually displayed
      }
    } as PagedResult;
    return result;
  }

  getItemsByID(requestMeta: RequestMetadata): Promise<PagedResult> {
    throw new Error("Method not implemented.");
  }
  getItem(row: any): Promise<any> {
    const filters = {};
    for (const key of this.primaryKeys) {
      filters[key] = { value: row[key] };
    }
    const requestMeta = {
      pageMeta: { currentPage: 1 },
      filters,
    } as RequestMetadata;
    return this.getItems(requestMeta)
      .then(data => data.items[0]);
  }

  post(item: any, methodName): Promise<number> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    }; 
    //console.log(item)
    this.url = environment.urlAddress + '/api/GoogleMaps/' + methodName;
    //https://www.positronx.io/angular-promises-example-manage-http-requests/
    return this.http
      .post<number>(this.url, item)
      .toPromise()
      .then(function (res) {
        return res;
      }.bind(this))
      .catch(this.handleError.bind(this));
  }

  put(item: any, methodName): Promise<number> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };
    this.url = environment.urlAddress + '/api/GoogleMaps/' + methodName;

    return this.http
      .put<number>(this.url, item)
      .toPromise()
      .then(function (res) {
        return res;
      }.bind(this))
      .catch(this.handleError.bind(this));
  }

  delete(IDOrName: any, methodName): Promise<any> {
    debugger;
    let params = new HttpParams()
      .set('IDOrName', IDOrName);

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers,
      params: params
    }; 
    this.url = environment.urlAddress + '/api/GoogleMaps/' + methodName;  //+ '/' + IDOrName;

    return this.http
      .delete<number>(this.url, options)
      .toPromise()
      .then(function (res) {
        return res;
      }.bind(this))
      .catch(this.handleError.bind(this));
  }

  getOptions(url: string, parentId: any): Promise<any> {
    return this.http.get(url)
      .toPromise()
      .then((response: any) => {
        const result = response.filter((value: any) => {
          return value.parentId === parentId;
        });
        return new Promise((resolve) => {
          setTimeout(() => resolve(result), 1000);
        });
      })
      .catch(this.handleError);
  }

  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    this.notifyService.sendMessage({ title: 'HttpErrorResponse', text: errorMessage, severity: 'error' });
    return Promise.reject(errorMessage);
  }
}
